import {Component, HostListener, NgModule, OnInit} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {RoofPanelSelectBoxComponent} from './roof-panel-select-box/roof-panel-select-box.component';
import {RouterPathService} from '../../../../core/common/variables/router-path.service';
import {TranslateService} from '../../../common/variables/translate-service';
import {ImagePathService} from '../../../common/variables/image-path.service';
import {RoofShape} from '../../../common/roof/RoofShape';
import {SC_Input} from '../../../common/input/SC_Input';
import {Global} from '../../../common/utilities/global';
import {MountingSystem} from '../../../common/mountsys/MountingSystem';
import {DrawRoofForPanel} from '../../../common/panel/drawRoofForPanel';
import {ModList} from '../../../common/panel/ModList';
import {SC_Beam} from '../../../common/roof/SC_Beam';
import {Actions, ofType} from '@ngrx/effects';
import {triggerPanel, triggerStatics} from '../../../store/senAppProjects.action';
import {DetailsStaticsComponent} from './details-statics/details-statics.component';
import {VarietyProfileComponent} from './variety-profile/variety-profile.component';
import {ModulProp} from '../../../common/panel/ModulProp';
import {Statics} from '../../../common/utilities/statics';
import {DrawFence} from '../../../common/fence/DrawFence';
import {Modul} from '../../../common/panel/Modul';
import {Store} from '@ngrx/store';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {RoofType} from '../../../common/roof/RoofType';
import {MountingType} from '../../../common/mountsys/MountingType';
import {GlobalService} from '../../../common/services/global.service';
import {GlobalFunctionService} from '../../../common/services/global-function.service';
import {GlobalVariableService} from '../../../common/variables/global-variable';
import {ModGroup} from '../../../common/panel/ModGroup';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfirmationBoxComponent} from '../../../common/components/confirmation-box/confirmation-box.component';
import genaratePanelSave, {getPanelCount, saveNonUsableAreas} from '../../../common/panel/savePanelDetails';
import {SubFrame} from '../../../common/mountsys/subFrame';
import {detailsOfNonUsableAreas} from '../../../store/senAppProjects.action';
import {Purlin_VProfile_isOptimal} from '../../../common/mountsys/vProfilPurlin';
import {SenLoaderService} from '../../../common/loader/sen-loader.service';
import {layoutCheckIntegrated} from '../../../common/panel/layoutCheckIntegrated';
import {PanelAutofillArea} from '../../../common/input/PanelAutofillArea';
import {RoofPlanSaveInput} from '../../../common/api/RoofPlanSave';
import {ProjectGetData} from '../../../common/api/ProjectGet';
import {RoofPlanGetData} from '../../../common/api/RoofPlanGet';
import checkForInvalid from '../../../common/panel/checkForInvalidPanels';
import {HGroup} from '../../../common/area/HGroup';
import {Sol50OnRoof} from '../../../common/mountsys/Sol50OnRoof';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

declare var $: any;

@Component({
    selector: 'sen-app-roof-panel',
    templateUrl: './roof-panel.component.html',
    styleUrls: ['./roof-panel.component.scss']
})

export class RoofPanelComponent implements OnInit {
    prevPath: string;
    nextPath: string;
    rows: number = 1;
    rows_count: number[] = [1];
    columns: number = 1;
    columnscount: number[] = [1];
    landscapeMode: boolean = false;
    imageWidth: number = 35;
    showBeamsFlag: boolean = true;
    showPanelsFlag: boolean = true;
    showNonUsesFlag: boolean = true;
    nonUsableAreaClass: DrawFence = new DrawFence();
    collapseIndex$: Observable<any[]>;
    resetPanelShow$: Observable<any[]>;
    selectedProject$: Observable<ProjectGetData>;
    selectedProject: ProjectGetData;
    selectedProjectUnSubscribe: Subscription;
    collapseIndexunSubscribe: Subscription;
    resetPanelShowSubscribe: Subscription;
    fenceName: string;
    fenceWidth: number;
    fenceHeight: number;
    fenceRadius: number;
    fenceX: number;
    fenceY: number;
    fenceX1: number;
    fenceY1: number;
    fenceX2: number;
    fenceY2: number;
    fenceX3: number;
    fenceY3: number;
    nonUsableArea$: Observable<any>;
    nonUsableAreaUnSubscribe: Subscription;
    panelCount$: Observable<any>;
    totalKW: number;
    panelCountUnSubscribe: Subscription;
    beamColorCode: string = '#000';
    sPanel: any = null;
    sPlanDetails: RoofPlanGetData;
    sHprofile: string = SC_Input.sHProfile ? SC_Input.sHProfile : GlobalVariableService.aHProfiles[1];
    isPanelDrawn: boolean = false;
    aData: any[] = [];
    collapseIndex: number = 1;
    varietyProfile: boolean = true;
    triggerPanelUnsubscribe: any;
    triggerStaticsUnsubscribe: any;
    enableNextBtn: boolean = true;
    isPanelsDrawnOnCanvas: any;
    enableDragLayout: any = false;
    showSubFrame: any = null;
    panelsOpacity: number = 1;
    subframeToggleBtn: boolean = false;
    showBoundaryAreaFlag: boolean = false;
    convertToLocalNumber: any = Global.convertToLocalNumber;
    panelLayoutMoveKey = 'Move the panel layout using shift + mouse move';
    IsmodelShow: boolean = false;
    edited: boolean = false;
    cutProfileLen: number = 10;
    cutProfileToggleBtn: boolean = false;
    cutlistbtn: any;
    cutlistGroup: any = [];
    iProfileLen: any;

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (Global.dragDropModules.allowPanelonRoof) {
            DrawRoofForPanel.isEscapeKeyPressed = true;
        }
    }


    constructor(public dialog: MatDialog,
                private action: Actions,
                private routerPath: RouterPathService,
                private store: Store<any>,
                public imagePath: ImagePathService,
                public global: GlobalVariableService,
                public globalService: GlobalService,
                public globalF: GlobalFunctionService,
                private router: Router,
                private loaderService: SenLoaderService,
                private route: ActivatedRoute,
                // private _mountSys: MountingSystem,
                private _snackBar: MatSnackBar,
                public translate: TranslateService) {
        if (DrawRoofForPanel.panelGroup) {
            DrawRoofForPanel.panelGroup.removeChildren();
        }
        this.prevPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPShapeString}`;
        this.nextPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPItemListString}`;
        this.selectedProject$ = this.store.select(state => {
            return state.appData.selectedProject;
        });
        this.selectedProject$.subscribe((data: ProjectGetData) => {
            this.selectedProject = data;
        });
        this.nonUsableArea$ = this.store.select(state => {
            return state.appData.nonUsableAreas.show;
        });
        this.nonUsableAreaUnSubscribe = this.nonUsableArea$.subscribe((data: any) => {
            this.fenceName = data.name;
            if (this.fenceName) {
                this.fenceName = this.fenceName.slice(0, 14);
            }

            if (!data.x2) {
                this.fenceX = Math.floor(data.x1);
                this.fenceY = Math.floor(data.y1);
                this.fenceX1 = Math.floor(0);
                this.fenceY1 = Math.floor(0);

            } else {
                this.fenceX = Math.floor(0);
                this.fenceY = Math.floor(0);
                this.fenceX1 = Math.floor(data.x1);
                this.fenceY1 = Math.floor(data.y1);

            }
            this.fenceX2 = Math.floor(data.x2);
            this.fenceY2 = Math.floor(data.y2);
            this.fenceX3 = Math.floor(data.x3);
            this.fenceY3 = Math.floor(data.y3);
            this.fenceWidth = Math.floor(data.width);
            this.fenceHeight = Math.floor(data.height);
            this.fenceRadius = Math.floor(data.radius);
        });
        this.resetPanelShow$ = this.store.select(state => {
            //console.log('state.appData.resetPanelShow',state);
            return state.appData.resetPanelShow;
        });
        this.resetPanelShowSubscribe = this.resetPanelShow$.subscribe((data: any) => {
            //console.log('data',data);
            if (DrawRoofForPanel.isSubframeEnabled) {
                this.onChangeSubFrameHandler({checked: false});
            }
        });

        this.collapseIndex$ = this.store.select(state => {
            return state.appData.collapseIndex;
        });
        this.collapseIndexunSubscribe = this.collapseIndex$.subscribe((data: any) => {
            this.collapseIndex = data.collapseIndex ? data.collapseIndex : 1;
            const obj: any = document.getElementById('toolIndex' + this.collapseIndex);
            if (obj) {
                obj.click();
            }
        });

        this.varietyProfile = MountingSystem.hasStatics();
        this.panelCount$ = this.store.select(state => {
            return state.appData.panelCount;
        });
        this.panelCountUnSubscribe = this.panelCount$.subscribe((data: any) => {
            this.subframeToggleBtn = false;
            this.totalKW = Global.getKW(data.count, parseInt(SC_Input.sModulPdc));
        });
        this.triggerStaticsUnsubscribe = this.action.pipe(ofType(triggerStatics)).subscribe(() => {
            this.loadStatics(true, false);
        });
        if (SC_Input.sPlanDetails) {
            this.setProjectPanel();
        }
        this.triggerPanelUnsubscribe = this.action.pipe(ofType(triggerPanel)).subscribe(() => {
            this.loadStatics(false, false, true);
            this.setProjectPanel();
        });
        Global.nonUsableArea = this.translate.getLng('OBSTRUCTIONS');
    }

    ngOnInit(): void {
        this.cardSetTimeOut();
        this.sPanel = SC_Input.sPanel;
        this.cutlistbtn = document.querySelector('.profile-cutlist');
        Global.dragDropModules.rows = this.rows;
        Global.dragDropModules.columns = this.columns;
        DrawRoofForPanel.enableDragLayout = this.enableDragLayout;
        // console.log(SC_Input.iModulCount);
        if (SC_Input.iModulCount > 0) {
            this.isPanelsDrawnOnCanvas = setInterval(() => {
                this.getpanelsCountOnRoof();
            }, 1000);
        } else {
            this.enableNextBtn = false;
        }
        // update panels from save.
        this.updateModule();
        // Calling function to draw by using Konva Lib.
        DrawRoofForPanel.onInit('panel_canvas_stage');

        // validation for saved plans: reset when it is roof type or size changes
        if (SC_Input.sPlanDetails) {
            if ((Global.iRoofShape == null && (SC_Input.iRoofShape != SC_Input.sPlanDetails.roofShape || SC_Input.a != SC_Input.sPlanDetails.roofA || SC_Input.b != SC_Input.sPlanDetails.roofB || SC_Input.c != SC_Input.sPlanDetails.roofC || SC_Input.d != SC_Input.sPlanDetails.roofD))) {
                Global.panelRows = [];
                SC_Input.sPlanDetails.panelRows = [];
                // SC_Input.sPlanDetails.roofObstructions = [];
                Global.roofObstructions = [];
            }
        }
        // reset panels and nonusable area when roof shape changes otherwise draw as it is.
        if (Global.iRoofShape == null || Global.iRoofShape == SC_Input.iRoofShape) {
            Global.iRoofShape = SC_Input.iRoofShape;
            if (Global.roofObstructions && Global.roofObstructions.length > 0) {
                //draw obstrctions from save
                DrawFence.drawFenceFromSaved(Global.roofObstructions);
            }
            // else if (SC_Input.sPlanDetails && SC_Input.sPlanDetails.roofObstructions!.length > 0) {
            //   if (SC_Input.sPlanDetails.roofShape == SC_Input.iRoofShape)
            //     DrawFence.drawFenceFromSaved(SC_Input.sPlanDetails.roofObstructions);
            // }
        } else {
            if (Global.iRoofShape != SC_Input.iRoofShape) {
                Global.iRoofShape = SC_Input.iRoofShape;
                Global.panelRows = [];
                if (Global.roofObstructions && Global.roofObstructions.length > 0) {
                    Global.roofObstructions = [];
                }
                // if (SC_Input.sPlanDetails && SC_Input.sPlanDetails.roofObstructions && SC_Input.sPlanDetails.roofObstructions.length > 0) SC_Input.sPlanDetails.roofObstructions = [];
                if (SC_Input.sPlanDetails && SC_Input.sPlanDetails.panelRows) {
                    SC_Input.sPlanDetails.panelRows = [];
                }
                // setTimeout(()=>{
                //   this.enableNextBtn = false;
                // },1000);
                let myPromise = new Promise(function(myResolve, myReject) {
                    // DrawRoofForPanel.drawModules();
                    myResolve(DrawRoofForPanel.drawModules());
                });
                myPromise.then(() => {
                    // console.log("then")
                    this.enableNextBtn = false;
                });
                myPromise.finally(() => {
                    // console.log("finally")
                    this.enableNextBtn = false;
                    setTimeout(() => {
                        DrawRoofForPanel.layerPanel.batchDraw();
                    }, 1000);
                });
                this.isPanelDrawn = true;
            }
        }

        //enable shift key drag and drop
        this.enableDragOnShiftKeyPressAndRelease();

        //
        this.iProfileLen = Sol50OnRoof.nHProfileLen;

        setTimeout(() => {

            // if (Global.toggleBoundaryArea || SC_Input.iPnlFillArea == PanelAutofillArea.ALL) {
            //   this.showBoundaryAreaFlag = Global.toggleBoundaryArea ? Global.toggleBoundaryArea : SC_Input.iPnlFillArea == PanelAutofillArea.ALL;
            if (Global.toggleBoundaryArea) {
                this.showBoundaryAreaFlag = Global.toggleBoundaryArea;
                const obj: any = DrawRoofForPanel.layerRoof.find('.boundaryArea');
                const inner = DrawRoofForPanel.layerRoof.find('.innerAreaShape');
                if (obj && obj.length > 0) {
                    obj.forEach((item: any) => {
                        if (Global.toggleBoundaryArea) {
                            item.opacity(0);
                            if (inner && inner[0]) {
                                inner[0].opacity(0);
                            }
                        } else {
                            if (inner && inner[0]) {
                                inner[0].opacity(1);
                            }
                            item.opacity(1);
                        }
                    });
                }
                DrawRoofForPanel.layerRoof.draw();
            }

        }, 100);
    }

    loadSavedModuls() {
        if (Global.roofHeight == 0 && Global.roofWidth == 0) {
            Global.roofWidth = RoofShape.getCurrentRoofWidth();
            Global.roofHeight = RoofShape.getCurrentRoofHeight();
        }
        if (Global.panelRows && Global.panelRows.length > 0) {
            if (RoofShape.getCurrentRoofWidth() == Global.roofWidth && RoofShape.getCurrentRoofHeight() == Global.roofHeight) {
                setTimeout(() => {
                    //load saved panels
                    Modul.drawPanelsFromSaved(Global.panelRows);
                }, 500);
            } else {
                // this.openDialog()
                // setTimeout(()=>{
                //   this.enableNextBtn = false;
                // },1000);
                let myPromise = new Promise((myResolve, myReject) => {

                    //subframe calculations
                    myResolve(DrawRoofForPanel.drawModules());
                });
                myPromise.then(() => {
                    // console.log("then")
                    this.enableNextBtn = false;
                });
                myPromise.finally(() => {
                    // console.log("finally")
                    this.enableNextBtn = false;
                });
            }
        } else if (SC_Input.sPlanDetails && SC_Input.sPlanDetails.panelRows.length > 0 && SC_Input.sPlanDetails.roofShape == SC_Input.iRoofShape) {
            setTimeout(() => {
                //load saved panels
                //console.log('SC_Input.sPlanDetails',SC_Input.sPlanDetails);
                Modul.drawPanelsFromSaved(SC_Input.sPlanDetails.panelRows);
            }, 500);

        } else {
            if (!this.isPanelDrawn) {
                this.openDialog();
            }
        }
        setTimeout(() => {
            this.checkInvalidPanels();
        }, 800);
        setTimeout(() => {
            genaratePanelSave();
        }, 1500);
    }

    toolCollapseIndex(n: string) {
        this.collapseIndex = parseInt(n);
    }

    removeAllShapes() {
        //console.log('remove all obstructions');
        var areas: any = DrawRoofForPanel.layerPanel.find('.' + Global.nonUsableArea);
        if (areas && areas.length > 0) {
            areas.forEach((i: any) => {
                i.destroy();
            });
            // if (SC_Input.sPlanDetails) SC_Input.sPlanDetails.roofObstructions = [];
            Global.roofObstructions = [];
            DrawFence.removeTransformNodes();

            //clear obstructions text if present
            DrawFence.clearObstructionTextIfAlreadyPresent();

            DrawRoofForPanel.layerPanel.batchDraw();
        }
    }

    removeSelectedShapes() {
        //console.log('remove selected obstruction')
        let name = ''; //classname = "", pointscount = 0,
        var obj: any = DrawRoofForPanel.layerPanel.find('.shapeTransform');
        if (obj && obj.length > 0) {
            obj.forEach((item: any) => {
                const shape = item.node();
                // classname = shape.getClassName();
                // if(classname !== "Circle")
                //   pointscount = shape?.getPoints()?.length;
                name = shape.getName();
                item.node().destroy();
                item.destroy();
            });
        }
        DrawFence.removeTransformNodes();
        //clear obstructions text if present
        DrawFence.clearObstructionTextIfAlreadyPresent();
        DrawRoofForPanel.layerPanel.batchDraw();
    }

    setProjectPanel() {
        if (!this.selectedProject.panelID || this.selectedProject.panelID == SC_Input.sPanel.id || this.selectedProject.roofPlans.length == 1) {
            SC_Input.sPlanDetails.projectPanel = true;
        } else {
            SC_Input.sPlanDetails.projectPanel = false;
        }
        this.sPlanDetails = SC_Input.sPlanDetails;
        this.sPanel = SC_Input.sPanel;
    }

    triggerStatics() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            title: this.translate.getLng('STAT_DETAILS'),
            buttons: {
                cancel: this.translate.getLng('CLOSE')
            },
            aData: this.aData
        };
        dialogConfig.disableClose = true;
        dialogConfig.width = '36vw';
        dialogConfig.position = {top: '10vh'};
        let dialogRef = this.dialog.open(DetailsStaticsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(() => {
            dialogRef.close();
        });
    }

    triggerProfiles() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            title: this.translate.getLng('VARIETY_PROFILE'),
            buttons: {
                cancel: this.translate.getLng('OK')
            },
            hProfileName: this.sHprofile
        };
        dialogConfig.disableClose = true;
        dialogConfig.width = '36vw';
        dialogConfig.position = {top: '10vh'};
        let dialogRef = this.dialog.open(VarietyProfileComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
            this.sHprofile = SC_Input.sHProfile = result;
            dialogRef.close();
        });
    }

    enableDrag() {
        this.enableDragLayout = !this.enableDragLayout;
        const con = document.getElementById('roof_panel_canvas_container');
        if (this.enableDragLayout && con) {
            con.classList.add('sen-cursor-move');
        } else {
            if (con) {
                con.classList.remove('sen-cursor-move');
            }
        }
        DrawRoofForPanel.stage.setDraggable(this.enableDragLayout);
        DrawRoofForPanel.stage.draw();
        DrawRoofForPanel.enableDragLayout = this.enableDragLayout;
        const nonUsableArea: any = DrawRoofForPanel.layerPanel.find('.' + Global.nonUsableArea);
        if (nonUsableArea && nonUsableArea.length > 0) {
            // console.log(nonUsableArea);
            this.deselectAllPanels();
            nonUsableArea.forEach((it: any) => {
                it.setDraggable(!this.enableDragLayout);
            });
        }

    }


    //enable/disable drag on shift Key Press And Release event
    enableDragOnShiftKeyPressAndRelease() {
        var stageContainer = DrawRoofForPanel.stage.container();

        //enable drag on ctrl key press
        stageContainer.addEventListener('keydown', (e: any) => {

            if (e.which == 16) {
                e.preventDefault();
                this.enableDragLayout = false;
                this.enableDrag();
            }
        });

        //disable drag on ctrl key release
        stageContainer.addEventListener('keyup', (e: any) => {
            if (e.which == 16) {
                e.preventDefault();
                this.enableDragLayout = true;
                this.enableDrag();
            }
        });
    }

    private updateSubframeDisplay(options: {
        isSubframeEnabled?: boolean;
        isProfileCutEnabled?: boolean;
        showPanels?: boolean,
        subframeOpacity?: number,
        panelOpacity?: number,
    } = {}) {
        const defaults = {
            isSubframeEnabled: true,
            isProfileCutEnabled: false,
            showPanels: false,
            subframeOpacity: 1,
            panelOpacity: 0,
        };

        const settings = { ...defaults, ...options };

        // Update state
        DrawRoofForPanel.isSubframeEnabled = settings.isSubframeEnabled;
        SubFrame.isProfileCutEnabled = settings.isProfileCutEnabled;
        this.showPanelsFlag = settings.showPanels;
        this.cutProfileToggleBtn = settings.isProfileCutEnabled;
        this.subframeToggleBtn = settings.isSubframeEnabled;

        // Update display
        DrawRoofForPanel.subframeGroup.removeChildren();
        SubFrame.drawFramework();
        DrawRoofForPanel.subframeGroup.opacity(settings.subframeOpacity);
        DrawRoofForPanel.panelGroup.opacity(settings.panelOpacity);
        DrawRoofForPanel.isViewPanelsEnabled = settings.showPanels;

        // Handle selected group opacity
        if (ModGroup.currentSelectedGroup) {
            ModGroup.currentSelectedGroup.opacity(settings.panelOpacity);
        }

        DrawRoofForPanel.layerPanel.batchDraw();
    }

    public updateModule(): void {
        //Modulfarbe nach Typ setzen
        if (SC_Input.iModType == ModulProp.TYPE_MONO) {
            Global.colModul = 0x222222;
        } else if (SC_Input.iModType == ModulProp.TYPE_POLY) {
            Global.colModul = 0x0c0054;
        } else if (SC_Input.iModType == ModulProp.TYPE_THIN) {
            Global.colModul = 0x350f05;
        } else {
            Global.colModul = 0x222222;
        }
        //Variables setzen
        MountingSystem.setVariables();
        //statik laden
        this.loadStatics(false, true);
    }

    loadStatics(statics?: boolean, module?: boolean, panelSelectionDone?: boolean) {
        let qParam: any = {
            cmd: this.global.StaticsGet,
            roofShape: SC_Input.iRoofShape,
            mountSystem: SC_Input.iMountSys,
            roofType: SC_Input.iRoofType,
            roofPitch: SC_Input.iRoofAngle,
            panelWidth: SC_Input.nModWidth,
            panelHeight: SC_Input.nModHeight,
            isNorthGermanPlain: SC_Input.isNorthGermanPlain
        };
        if (SC_Input.iRoofType == RoofType.SLATED) {
            qParam.battenDivision = SC_Input.iBattenDivision;
        } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
            qParam.mountingType = SC_Input.iMountingType;
            if (SC_Input.trapezPara != null) {
                qParam.trapezMaterial = SC_Input.trapezPara.iMaterial;
            }
            if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
                qParam.purlinMaterial = SC_Input.iBeamMat;
            }
        }
        if (SC_Input.bBeam) {
            if (SC_Input.iBeamType == SC_Beam.RAFTER) {
                qParam.beamSpace = SC_Input.nBeamDist;
                qParam.roofHookType = SC_Input.roofhookinputCurrent.iType;
            } else if (SC_Input.iBeamType == SC_Beam.PURLIN) {
                qParam.beamSpace = SC_Input.nBeamDist;
            }
        }


        //get statistics from backend to check snowload etc for validating the panels
        //this.loadSavedModuls();  - load the saved panels  from backend
        this.globalService.getData(qParam).subscribe((data: any) => {
            try {
                if (data.ok.data) {
                    if (panelSelectionDone) {
                        setTimeout(() => {
                            //drawing panels on ok button in modal
                            DrawRoofForPanel.drawModules();
                            DrawRoofForPanel.layerPanel.batchDraw();
                        }, 110);
                        setTimeout(() => {
                            this.checkInvalidPanels();
                        }, 800);
                        setTimeout(() => {
                            genaratePanelSave();
                        }, 1500);
                    }
                    this.triggerStaticsChange(data.ok.data, statics);
                }
            } catch {
            } finally {
                if (statics) {
                    this.triggerStatics();
                }
                setTimeout(() => {
                    if (module) {
                        //load panel from save
                        this.loadSavedModuls();
                    }
                    this.aData = this.globalF.staticDetailToSave();
                }, 500);
            }
        });
    }

    triggerStaticsChange(data: any, statics?: boolean) {
        Statics.StaticsHandler(data);
    }

    drawModules(): void {
        if (SC_Input.iRoofShape == RoofShape.PULT) {
            MountingSystem.fitRechteck();
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            MountingSystem.fitRechteck();
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            MountingSystem.fitWalm();
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            MountingSystem.fitRechteck();
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            MountingSystem.fitKrueppelwalm();
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            MountingSystem.fitRechteck();
        }

        setTimeout(() => {
            DrawRoofForPanel.layerPanel.draw();
        }, 100);
    }

    openDialog(): void {
        this.enableNextBtn = false;
        const dialogRef = this.dialog.open(RoofPanelSelectBoxComponent, {
            width: '44vw',
            data: {
                action: false,
                panelData: this.sPanel,
                projectData: this.selectedProject
            },
            disableClose: true,
            autoFocus: false,
            panelClass: 'sen-panel-select-box'
        });
    }

    selectedPanelHandler() {
        let isPanelRemove = false;
        if (ModGroup.currentSelectedGroup) {
            isPanelRemove = true;
            ModGroup.currentSelectedGroup.destroy();
            ModGroup.currentSelectedGroup = null;
        }
        if (ModList.currentSelectedPanel) {
            isPanelRemove = true;
            DrawRoofForPanel.singlePanelDelete();
            // ModList.currentSelectedPanel = null
        }
        if (isPanelRemove) {
            DrawRoofForPanel.layerPanel.batchDraw();
            setTimeout(() => {
                Modul.isPanelMoved = true;
                genaratePanelSave();
            }, 500);
        }
    }

    getpanelsCountOnRoof() {
        if (DrawRoofForPanel && DrawRoofForPanel.layerPanel) {
            var obj: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
        }
        //console.log('SC_Input.iModulCount',SC_Input.iModulCount);
        //console.log('obj.length',obj.length);
        if (obj && obj.length > 0) {
            if (SC_Input.iModulCount == obj.length) {
                this.enableNextBtn = false;
            }
            clearInterval(this.isPanelsDrawnOnCanvas);
        }
    }

    invalidPanel_removeHandler() {
        var obj: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
        if (obj && obj.length > 0) {
            obj.forEach((item: any) => {
                const a = item.find('.invalidPanels');
                if (a && a[0]) {
                    if (a[0].getOpacity() == 1) {
                        item.destroy();
                    }
                }
            });
            Modul.isPanelMoved = true;
        }
        DrawRoofForPanel.layerPanel.batchDraw();
        // Need to update panel count
        setTimeout(() => {
            genaratePanelSave();
        }, 500);
    }

    // isInvalidPanelsAvilable(): boolean {
    //   let flag = false;
    //   var obj: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
    //   if (obj && obj.length > 0)
    //     obj.forEach((item: any) => {
    //       const a = item.find(".invalidPanels");
    //       if (a && a[0]) {
    //         if (a[0].getOpacity() == 1) {
    //           flag = true;
    //         }
    //       }
    //     });
    //   return flag;
    // }

    findForPanelErrors(): any {
        let isInvalidPanelsAval = false;
        let isCanTilAval = false;
        let outOfRoof = false;
        var obj: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
        if (obj && obj.length > 0) {
            obj.forEach((item: any) => {
                const a = item.find('.invalidPanels');
                if (a && a[0]) {
                    if (a[0].getOpacity() == 1) {
                        isInvalidPanelsAval = true;
                    }
                }
                const b = item.find('.canTilEver');
                if (b && b[0]) {
                    if (b[0].getOpacity() == 1) {
                        isCanTilAval = true;
                    }
                    const start = 100;
                    const attrs = item.getAttrs();
                    const pW = attrs.width;
                    const pH = attrs.height;
                    const h = RoofShape.getCurrentRoofHeight() + 100;
                    const w = RoofShape.getCurrentRoofWidth() + 100;
                    if (!outOfRoof && !(attrs.x > start && attrs.x < w) || !(attrs.y > start && attrs.y < h)) {
                        outOfRoof = true;
                    }
                    if (!outOfRoof && !((attrs.x + pW) > start && (attrs.x + pW) < w) || !((attrs.y + pH) > start && (attrs.y + pH) < h)) {
                        outOfRoof = true;
                    }
                    if (!outOfRoof && (SC_Input.iRoofShape == RoofShape.WALM || SC_Input.iRoofShape == RoofShape.KRUEPPELWALM)) {
                        // Hip
                        const a = SC_Input.iRoofShape == RoofShape.WALM ? SC_Input.a : SC_Input.d;
                        const b = SC_Input.b;
                        const c = SC_Input.c;
                        const nWing = (b - c) / 2;
                        const area = (x1: number, y1: number, x2: number, y2: number, x3: number, y3: number) => {
                            return Math.abs((x1 * (y2 - y3) + x2 * (y3 - y1) + x3 * (y1 - y2)) / 2.0);
                        };
                        const isInside = (x1: number, y1: number, x2: number, y2: number, x3: number, y3: number, x: number, y: number) => {
                            /* Calculate area of triangle ABC */
                            let A = area(x1, y1, x2, y2, x3, y3);

                            /* Calculate area of triangle PBC */
                            let A1 = area(x, y, x2, y2, x3, y3);

                            /* Calculate area of triangle PAC */
                            let A2 = area(x1, y1, x, y, x3, y3);

                            /* Calculate area of triangle PAB */
                            let A3 = area(x1, y1, x2, y2, x, y);

                            /* Check if sum of A1, A2 and A3 is same as A */
                            return (A == A1 + A2 + A3);
                        };
                        // triangleShape points
                        //Left one
                        let x1 = 100;
                        let y1 = 100;
                        let x2 = nWing + 100;
                        let y2 = 100;
                        let x3 = 100;
                        let y3 = a + 100;

                        const findLeftSide = isInside(x1, y1, x2, y2, x3, y3, attrs.x, attrs.y);
                        //Rigthside one
                        x1 = b - nWing + 100;
                        y1 = 100;
                        x2 = b + 100;
                        y2 = 100;
                        x3 = b + 100;
                        y3 = a + 100;
                        const findRightSide = isInside(x1, y1, x2, y2, x3, y3, attrs.x + pW, attrs.y + pH);
                        const findRightSideUp = isInside(x1, y1, x2, y2, x3, y3, attrs.x + pW, attrs.y);
                        if (findLeftSide || findRightSide || findRightSideUp) {
                            outOfRoof = true;
                        }
                    }
                }
            });
        }
        var ellipseError = this.findEllipseError();

        // const ellipseError = ellipse.length > 0;
        return {
            isInvalidPanelsAval: isInvalidPanelsAval,
            isCanTilAval: isCanTilAval,
            ellipseError: ellipseError,
            outOfRoof: outOfRoof
        };
    }

    // iscanTilEverPanelsAvilable(): boolean {
    //   let flag = false;
    //   var obj: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
    //   if (obj && obj.length > 0)
    //     obj.forEach((item: any) => {
    //       const a = item.find(".canTilEver");
    //       if (a && a[0]) {
    //         if (a[0].getOpacity() == 1) {
    //           flag = true;
    //         }
    //       }
    //     });
    //   return flag;
    // }
    findEllipseError(): boolean {
        let ellipseError = false;
        var ellipse: any = DrawRoofForPanel.layerPanel.find('.ellipseError');
        if (ellipse.length > 0) {
            ellipse.forEach((err: any) => {
                const attrs = err.getAttrs();
                if ((attrs.radiusX > 0 && attrs.radiusY > 0) || (attrs.points && attrs.points.length > 0)) {
                    ellipseError = true;
                }
            });
        }
        return ellipseError;
    }

    findInvalidPanels(): boolean {
        let invalidPanels = false;
        var obj: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
        if (obj && obj.length > 0) {
            obj.forEach((item: any) => {
                const a = item.find('.invalidPanels');
                if (a && a[0]) {
                    if (a[0].getOpacity() == 1) {
                        invalidPanels = true;
                    }
                }
            });
        }
        return invalidPanels;
    }

    panel_removeHandler() {
        var obj: any = DrawRoofForPanel.layerPanel.find('.' + Global.panelsOnRoof);
        if (obj && obj.length > 0) {
            obj.forEach((item: any) => {
                item.destroy();
            });
        }
        layoutCheckIntegrated.removeAllEllipse();
        DrawRoofForPanel.layerPanel.draw();
        ModList.listOfModules = [];
        Modul.panelCount = 0;
        ModList.currentSelectedPanel = null;

        if (ModGroup.currentSelectedGroup) {
            ModGroup.currentSelectedGroup.destroy();
            ModGroup.currentSelectedGroup = null;
        }

        //console.log('ModGroup.currentSelectedGroup',ModGroup.currentSelectedGroup);

        if (SC_Input.sPlanDetails) {
            SC_Input.sPlanDetails.panelRows = [];
        }
        Global.hgroups = [];
        Global.panelRows = [];
        setTimeout(() => {
            genaratePanelSave();
            getPanelCount();
        }, 1500);
    }

    toggleBoundaryArea(event: any) {
        if (DrawRoofForPanel.isSubframeEnabled) {
            this.onChangeSubFrameHandler({checked: false});
        }

        Global.toggleBoundaryArea = !Global.toggleBoundaryArea;
        if (Global.toggleBoundaryArea) {
            SC_Input.iPnlFillArea = PanelAutofillArea.ALL;
        } else {
            SC_Input.iPnlFillArea = PanelAutofillArea.INNER;
        }
        this.checkInvalidPanels();
        this.showBoundaryAreaFlag = Global.toggleBoundaryArea;

        const obj: any = DrawRoofForPanel.layerRoof.find('.boundaryArea');
        const inner = DrawRoofForPanel.layerRoof.find('.innerAreaShape');
        if (obj && obj.length > 0) {
            obj.forEach((item: any) => {
                if (Global.toggleBoundaryArea) {
                    item.opacity(0);
                    if (inner && inner[0]) {
                        inner[0].opacity(0);
                    }
                } else {
                    if (inner && inner[0]) {
                        inner[0].opacity(1);
                    }
                    item.opacity(1);
                }
            });
        }
        DrawRoofForPanel.layerRoof.draw();
        if (Statics.oCantileverMin && Statics.oCantileverMax && Statics.oVerticalCantileverMax) {
            MountingSystem.checkCantilever();
        }
    }

    checkInvalidPanels() {
        ModGroup.checkInvalidPanels();
    }

    rowscountHandler() {

        if (this.rows_count.length > this.rows) {
            this.rows_count.pop();
            this.imageWidth += 2;
        } else {
            this.rows_count.push(1);
            this.imageWidth -= 2;
        }
        Global.dragDropModules.rows = this.rows;
        this.updateStyle();
        // this.updatePanelsDislay();

    }

    columnscountHandler() {

        if (this.columnscount.length > this.columns) {
            this.columnscount.pop();
        } else {
            this.columnscount.push(1);
        }
        Global.dragDropModules.columns = this.columns;

        this.updateStyle();
    }

    updateStyle() {
        this.updatePanelsDislay();
    }

    zoomInOut(s: string) {
        DrawRoofForPanel.zoomInOut(s);
    }

    onChangeShowBeam(e: any) {
        this.showBeamsFlag = e.checked;
        var beams: any = DrawRoofForPanel.layerBeam.getChildren();
        beams.forEach((item: any) => {
            if (this.showBeamsFlag) {
                item.show();
            } else {
                item.hide();
            }
        });
        DrawRoofForPanel.layerBeam.draw();

    }

    onChangeShowPanel(e: any) {
        this.showPanelsFlag = e.checked;

        // DrawRoofForPanel.panelGroup.opacity()
        if (this.showPanelsFlag) {
            DrawRoofForPanel.isViewPanelsEnabled = true;
            DrawRoofForPanel.panelGroup.opacity(this.panelsOpacity);
            if (ModGroup.currentSelectedGroup) {
                ModGroup.currentSelectedGroup.opacity(this.panelsOpacity);
            }
        } else {
            DrawRoofForPanel.panelGroup.opacity(0);
            DrawRoofForPanel.isViewPanelsEnabled = false;
            if (ModGroup.currentSelectedGroup) {
                ModGroup.currentSelectedGroup.opacity(0);
            }
        }
        DrawRoofForPanel.layerPanel.draw();
        // console.log(DrawRoofForPanel.isViewPanelsEnabled)
    }

    onChangeTransparency(e: any) {
        this.panelsOpacity = (1 - e.value / 100);
        DrawRoofForPanel.panelGroup.opacity(this.panelsOpacity);
        if (ModGroup.currentSelectedGroup) {
            ModGroup.currentSelectedGroup.opacity(this.panelsOpacity);
        }
        DrawRoofForPanel.layerPanel.batchDraw();
    }

    onChangeOfShowNonUsesFlag(e: any) {
        // this.non UsableArea = e.checked;
        var areas: any = DrawRoofForPanel.layerPanel.find('.' + Global.nonUsableArea);
        areas.forEach((item: any) => {
            if (e.checked) {
                item.show();
            } else {
                item.hide();
            }
        });
        DrawRoofForPanel.layerPanel.draw();
    }

    onchangeBeamColor(e: any) {
        SC_Beam.colorCode = e;
        DrawRoofForPanel.layerBeam.removeChildren();
        SC_Beam.drawBeam(DrawRoofForPanel.layerBeam);
        SC_Beam.layerBeam.draw();
    }

    checkEllipseError(e: any) {
        if (ModGroup.currentSelectedGroup) {
            ModGroup.moveBackToMainGroup();
        }
        if (this.findEllipseError()) {
            e.preventDefault();
            this._snackBar.open(this.translate.getLng('ELLIPSE_ERROR'));
        }
        if (this.findInvalidPanels()) {
            e.preventDefault();
            this._snackBar.open(this.translate.getLng('MOD_REM_INV'));
        }
    }

    onChangeSubFrameHandler(e: any) {
        if (this.showSubFrame) {
            clearTimeout(this.showSubFrame);
            this.showSubFrame = null;
        }

        if (e.checked) {
            this.showSubFrame = setTimeout(() => {
                this.updateSubframeDisplay({
                    showPanels: false,
                    subframeOpacity: 1,
                    panelOpacity: 0
                });
            }, 200);
        } else {
            this.updateSubframeDisplay({
                isSubframeEnabled: false,
                showPanels: true,
                subframeOpacity: 0,
                panelOpacity: this.panelsOpacity,
            });
        }
    }

    onClickHandlerDraw(name: string) {
        // if (DrawRoofForPanel.isSubframeEnabled)
        //   this.onChangeSubFrameHandler({ checked: false });
        this.nonUsableAreaClass.crateNewShape(name);
        if (!DrawFence.storeObj) {
            DrawFence.storeObj = this.store;
        }
        var oldDom: any = document.getElementsByClassName('sen-activebg-fence');
        if (oldDom.length > 0) {
            oldDom[0].classList.remove('sen-activebg-fence');
        }
        var element: any = document.getElementById(name);
        element.classList.add('sen-activebg-fence');
        setTimeout(() => {
            this.deselectAllPanels();
        }, 1);
    }

    landscapeHandler(event: any) {
        this.landscapeMode = event.checked;
        if (this.landscapeMode) {
            // SC_Input.iModAlignment = ModulProp.ORIENTATION_HORIZONTAL
            Global.dragDropModules.portrait = false;
        } else {
            // SC_Input.iModAlignment = ModulProp.ORIENTATION_VERTICAL;
            Global.dragDropModules.portrait = true;
        }
        this.updatePanelsDislay();
    }

    updatePanelsDislay() {
        var obj = document.getElementById('draggable');
        var scalefactor = 1; // this.columns > 2 || this.rows > 2 ? 0.5 : 1;
        if (this.landscapeMode) {
            if (obj) {
                obj.style.transform = 'rotate(90deg) scale(' + scalefactor + ')';
            }
        } else {
            if (obj) {
                obj.style.transform = 'rotate(0deg)  scale(' + scalefactor + ')';
            }
        }
    }

    private isPanelSizeValid(): Boolean {
        var bRet: Boolean;
        if (SC_Input.nModHeight > this.global.PANEL_SIZE_MAX || SC_Input.nModWidth > this.global.PANEL_SIZE_MAX || SC_Input.nModHeight < this.global.PANEL_SIZE_MIN || SC_Input.nModWidth < this.global.PANEL_SIZE_MIN) {
            bRet = false;
        } else {
            bRet = true;
        }
        return bRet;
    }

    onResize(event: any) {
        this.resetStagePosition(true);
    }

    resetStagePosition(stageOutInvalidPanels: any) {
        //console.log('reset stage zoom');//stageOutInvalidPanels - if panels outside left and right position out of roof
        const obj: any = this.getMinAndMaxValues(stageOutInvalidPanels);
        //console.log('resetStagePosition obj.min.x',obj.min.x);
        //console.log('resetStagePosition obj.min.y',obj.min.y);
        //console.log('resetStagePosition obj.max.x',obj.max.x);
        //console.log('resetStagePosition obj.max.y',obj.max.y);
        const roofMax = {x: (RoofShape.getCurrentRoofWidth() + 150), y: (RoofShape.getCurrentRoofHeight() + 150)};
        const roofMin = {x: 0, y: 0};
        obj.max.x = obj.max.x < roofMax.x ? roofMax.x : obj.max.x;
        obj.max.y = obj.max.y < roofMax.y ? roofMax.y : obj.max.y;
        obj.min.x = obj.min.x < 0 ? obj.min.x : 1;
        obj.min.y = obj.min.y < 0 ? obj.min.y : 1;
        //console.log('resetStagePosition 1 obj.min.x',obj.min.x);
        //console.log('resetStagePosition 1 obj.min.y',obj.min.y);
        //console.log('resetStagePosition 1 obj.max.x',obj.max.x);
        //console.log('resetStagePosition 1 obj.max.y',obj.max.y);
        if (obj.min.x > 0 && obj.min.x && obj.max.x < roofMax.x && obj.max.y < roofMax.y) {
            //console.log('if reset');
            DrawRoofForPanel.setDefaultScaleToStage();
            DrawRoofForPanel.stage.x(0);
            DrawRoofForPanel.stage.y(0);
            DrawRoofForPanel.stage.scaleX(DrawRoofForPanel.currentScale);
            DrawRoofForPanel.stage.scaleY(DrawRoofForPanel.currentScale);
        } else {
            //console.log('else reset');
            const position: any = document.getElementById('roof_panel_canvas_container');
            const scaleX = position.offsetWidth / (obj.max.x - obj.min.x + 250);
            const scaleY = position.offsetHeight / (obj.max.y - obj.min.y + 250);
            //DrawRoofForPanel.stage.scaleX ,DrawRoofForPanel.stage.scaleY matters for zoom in and out for panels
            DrawRoofForPanel.currentScale = scaleX > scaleY ? scaleY : scaleX;
            DrawRoofForPanel.stage.scaleX(DrawRoofForPanel.currentScale);
            DrawRoofForPanel.stage.scaleY(DrawRoofForPanel.currentScale);
            DrawRoofForPanel.stage.x(obj.min.x < 0 ? -obj.min.x * scaleX : 0);
            DrawRoofForPanel.stage.y(obj.min.y < 0 ? -obj.min.y * scaleY : 0);
            //console.log(obj.min.x < 0 ?  - obj.min.x * scaleX: 0 ,'obj.min.x < 0 ?  - obj.min.x * scaleX: 0');
            //console.log(obj.min.y < 0 ?  - obj.min.y * scaleY: 0 , 'obj.min.y < 0 ?  - obj.min.y * scaleY: 0');
            //console.log(DrawRoofForPanel.stage)
        }
        DrawRoofForPanel.stage.draw();
        DrawRoofForPanel.getCurrentsize();
        DrawRoofForPanel.isZoomed = false;
    }


    getMinAndMaxValues(stageOutInvalidPanels: any): any {
        let obj: any = {
            min: {x: null, y: null},
            max: {x: null, y: null}
        };
        let temp;
        for (let j = 0; j < Global.hgroups.length; j++) {
            temp = new HGroup(Global.hgroups[j]);

            //console.log('invalidPanels isPanelisInvalidPanel',temp.x);
            if (stageOutInvalidPanels) {

                if (temp.x > 0) {

                    if (obj.min.x === null) {
                        obj.min.x = temp.x;
                    } else {
                        obj.min.x = temp.x < obj.min.x ? temp.x : obj.min.x;
                    }
                    if (obj.max.x === null) {
                        obj.max.x = temp.x + temp.width;
                    } else {
                        obj.max.x = (temp.x + temp.width) > obj.max.x ? (temp.x + temp.width) : obj.max.x;
                    }

                }

                if (temp.y > 0) {

                    if (obj.min.y === null) {
                        obj.min.y = temp.y;
                    } else {
                        obj.min.y = temp.y < obj.min.y ? temp.y : obj.min.y;
                    }
                    if (obj.max.y === null) {
                        obj.max.y = temp.y + temp.height;
                    } else {
                        obj.max.y = (temp.y + temp.height) > obj.max.y ? (temp.y + temp.height) : obj.max.y;
                    }
                }

            } else {
                if (obj.min.x === null) {
                    obj.min.x = temp.x;
                } else {
                    obj.min.x = temp.x < obj.min.x ? temp.x : obj.min.x;
                }
                if (obj.max.x === null) {
                    obj.max.x = temp.x + temp.width;
                } else {
                    obj.max.x = (temp.x + temp.width) > obj.max.x ? (temp.x + temp.width) : obj.max.x;
                }


                if (obj.min.y === null) {
                    obj.min.y = temp.y;
                } else {
                    obj.min.y = temp.y < obj.min.y ? temp.y : obj.min.y;
                }
                if (obj.max.y === null) {
                    obj.max.y = temp.y + temp.height;
                } else {
                    obj.max.y = (temp.y + temp.height) > obj.max.y ? (temp.y + temp.height) : obj.max.y;
                }
            }

        }
        if (Global.hgroups.length === 0) {
            obj = {
                min: {x: 0, y: 0},
                max: {x: RoofShape.getCurrentRoofWidth(), y: RoofShape.getCurrentRoofHeight()}
            };
        }

        return obj;
    }


    setNameToShape(n?: any) {
        DrawFence.selectedShape.setId(n.target.value);

        DrawRoofForPanel.stage.draw();
    }

    setSizeToShape(n?: any, type?: any) {
        let w = parseFloat(n.target.value) + ((type == 'x' || type == 'y') ? 100 : 0);
        if (DrawFence.selectedShape.getClassName() === 'Line' && DrawFence.selectedShape.getPoints().length == 8) {
            const p = DrawFence.selectedShape.getPoints();
            if (type == 'w') {
                DrawFence.selectedShape.setPoints([p[0], p[1], p[0] + w, p[1], p[0] + w, p[5], p[0], p[7]]);
            }
            if (type == 'h') {
                DrawFence.selectedShape.setPoints([p[0], p[1], p[2], p[3], p[4], p[1] + w, p[6], p[1] + w]);
            }
            if (type == 'x') {
                w -= p[0];
                DrawFence.selectedShape.setPoints([p[0] + w, p[1], p[2] + w, p[3], p[4] + w, p[5], p[6] + w, p[7]]);
            }
            if (type == 'y') {
                w -= p[1];
                DrawFence.selectedShape.setPoints([p[0], p[1] + w, p[2], p[3] + w, p[4], p[5] + w, p[6], p[7] + w]);
            }
            // DrawRoofForPanel.stage.draw();
        }
        if (DrawFence.selectedShape.getClassName() === 'Line' && DrawFence.selectedShape.getPoints().length == 6) {
            const p = DrawFence.selectedShape.getPoints();
            w = w + 100;
            if (type == 'x1') {
                DrawFence.selectedShape.setPoints([w, p[1], p[2], p[3], p[4], p[5]]);
            }
            if (type == 'y1') {
                DrawFence.selectedShape.setPoints([p[0], w, p[2], p[3], p[4], p[5]]);
            }
            if (type == 'x2') {
                DrawFence.selectedShape.setPoints([p[0], p[1], w, p[3], p[4], p[5]]);
            }
            if (type == 'y2') {
                DrawFence.selectedShape.setPoints([p[0], p[1], p[2], w, p[4], p[5]]);
            }
            if (type == 'x3') {
                DrawFence.selectedShape.setPoints([p[0], p[1], p[2], p[3], w, p[5]]);
            }
            if (type == 'y3') {
                DrawFence.selectedShape.setPoints([p[0], p[1], p[2], p[3], p[4], w]);
            }

        } else {

            if (type == 'r') {
                DrawFence.selectedShape.setRadius(w);
            }
            if (type == 'x') {
                DrawFence.selectedShape.x(w);
            }
            if (type == 'y') {
                DrawFence.selectedShape.y(w);
            }
        }
        DrawFence.clearPanels();
        DrawRoofForPanel.stage.draw();
    }

    deselectAllPanels() {
        if (ModList.currentSelectedPanel) {
            Modul.deselection();
        }
        //console.log('entere deselectAllPanels');
        if (ModGroup.currentSelectedGroup) {
            ModGroup.moveBackToMainGroup();
        }
        DrawFence.removeTransformNodes();

        //clear obstructions text if present
        DrawFence.clearObstructionTextIfAlreadyPresent();

        DrawRoofForPanel.layerPanel.batchDraw();
    }

    goPrev() {

        this.deselectAllPanels();
        this.resetStagePosition(true);
        saveNonUsableAreas();
        //console.log('goPrev');
        genaratePanelSave();
        this.roofStageBydefault();
        SC_Input.bLoadedProject = false;
        if (!Statics.bBadModulesExist) {
            MountingSystem.rememberObjects();
        }
        this.router.navigate([this.prevPath], {relativeTo: this.route});
    }

    goNext1() {
        this.deselectAllPanels();
        this.resetStagePosition(true);
        //console.log('goNext1');
        saveNonUsableAreas();
        genaratePanelSave();
        const errors = this.findForPanelErrors();
        if (errors.isInvalidPanelsAval) {
            this._snackBar.open(this.translate.getLng('MOD_REM_INV'));
            return;
        }
        if (errors.ellipseError) {
            this._snackBar.open(this.translate.getLng('ELLIPSE_ERROR'));
            return;
        }
        if (errors.outOfRoof) {
            this._snackBar.open(this.translate.getLng('OUTOF_ROOF_PANEL'));
            return;
        }
        if (errors.isCanTilAval) {
            Global.cantileverValid = false;
            // this._snackBar.open("Cantilever invalid. Do you want to continue however?");
            // return;
        } else {
            Global.cantileverValid = true;
        }

        if (ModList.iCount < 1) {
            this._snackBar.open(this.translate.getLng('NO_MODULES'));
            return;
        }
        if (!MountingSystem.getErrorInvalidGroups()) {
            this._snackBar.open(this.translate.getLng('AD_INVALID_GROUPS'));
            return;
        }
        if (Statics.getPlanable() == Statics.PLANABLE_NO) {
            this._snackBar.open(this.translate.getLng('BAD_STA_VAL'));
            return;
        }
        if (!this.isPanelSizeValid()) {
            this._snackBar.open(this.translate.getLng('PANEL_SIZE_INVALID'));
            return;
        }
        if (Statics.bBadModulesExist) {
            this._snackBar.open(`${this.translate.getLng('INVALID_MODULES')}\n${this.translate.getLng('LOOKAT')} '${this.translate.getLng('STATIC')}' -> '${this.translate.getLng('NORANGE')}', ${this.translate.getLng('HINT')}`);
            return;
        }
        this.goNext2();
    }

    goNext2() {
        //console.log('goNext2');
        if (SC_Input.bBeam && SC_Input.iBeamType == SC_Beam.PURLIN) {
            //purlin
            if (!Purlin_VProfile_isOptimal()) {
                let dialogRef = this.globalF.openConfirmationBox('PURL_WARN_UNWA');
                dialogRef.afterClosed().subscribe((result: boolean) => {
                    dialogRef.close();
                    if (result) {
                        this.goNext3();
                    }
                });
                return;
            }
        }
        this.goNext3();
    }


    goNext3() {
        //console.log('goNext3');
        const errors = this.findForPanelErrors();
        this.goNext4();
        SC_Input.bKragarm = true;
    }

    goNext4() {
        DrawRoofForPanel.setDefaultScaleToStage();
        let obj: any = DrawRoofForPanel.layerPanel.find('.canTilEver');
        if (obj && obj.length > 0) {
            obj.forEach((item: any) => {
                item.opacity(0);
            });
        }
        this.drawMesurments();
        this.loaderService.isLoading.next(true);
        DrawRoofForPanel.panelGroup.opacity(1);
        DrawRoofForPanel.layerPanel.draw();
        Global.panelOverviewImage = DrawRoofForPanel.stage.toDataURL({'pixelRatio': 1});
        this.roofStageBydefault();
        SC_Input.iModulCount = getPanelCount();// ModList.iCount;
        SubFrame.drawFramework();
        setTimeout(() => {
            DrawRoofForPanel.subframeGroup.removeChildren();
            SubFrame.drawFramework();
            DrawRoofForPanel.subframeGroup.opacity(1);
            this.subframeMesurment();
            DrawRoofForPanel.layerPanel.draw();
        }, 1000);
        this.showPanelsFlag = false;
        DrawRoofForPanel.panelGroup.opacity(0);
        setTimeout(() => {
            Global.panelSubframeImage = DrawRoofForPanel.stage.toDataURL({'pixelRatio': 1});

            this.showSubframeProfileCut();
            SubFrame.drawFramework();
            Global.panelSubframeProfileCutImage = DrawRoofForPanel.stage.toDataURL({'pixelRatio': 1});
            this.removeSubFrameProfileCut();
            this.goNext5();
        }, 2000);
    }

    goNext5() {
        MountingSystem.rememberObjects();
        SC_Input.sPlanDetails = this.sPlanDetails;
        this.loaderService.isLoading.next(false);
        this.router.navigate([this.nextPath], {relativeTo: this.route});
    }

    downloadURI(uri: any, name: any) {
        var link = document.createElement('a');
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    roofStageBydefault() {
        this.updateSubframeDisplay({
            isSubframeEnabled: false,
            showPanels: true,
            subframeOpacity: 0,
            panelOpacity: 1,
        });
    }

    ngOnDestroy() {
        this.roofStageBydefault();
        DrawRoofForPanel.stage.destroy();
        this.triggerPanelUnsubscribe.unsubscribe();
        this.triggerStaticsUnsubscribe.unsubscribe();
        this.nonUsableAreaUnSubscribe.unsubscribe();
        this.collapseIndexunSubscribe.unsubscribe();
        // this.panelCountUnSubscribe.unsubscribe();
        // this.selectedProjectUnSubscribe.unsubscribe();
    }

    nonusablearea() {

        this.store.dispatch(detailsOfNonUsableAreas({show: true}));
    }

    allowPanelonRoof() {
        if (DrawRoofForPanel.isSubframeEnabled) {
            this.onChangeSubFrameHandler({checked: false});
        }
        Global.dragDropModules.allowPanelonRoof = true;
        //console.log('allow panels on roof', Global.dragDropModules.allowPanelonRoof);
        setTimeout(() => {
            this.deselectAllPanels();
        }, 1);
    }

    drawMesurments() {
        DrawRoofForPanel.drawMesurments();
    }

    subframeMesurment() {
        DrawRoofForPanel.subframeMesurment();
    }

    cardClose() {
        this.IsmodelShow = true;
    }

    cardSetTimeOut() {
        this.edited = true;
        setTimeout(function(this: any) {
            this.edited = false;
        }.bind(this), 20000);
    }

    //onChangeCutProfileLen
    onChangeCutProfileLen() {

        Sol50OnRoof.cutProfileLen = this.cutProfileLen;
        DrawRoofForPanel.isSubframeEnabled = true;
        SubFrame.isProfileCutEnabled = true;
        this.cutProfileToggleBtn = true;
        this.subframeToggleBtn = true;
        this.showSubFrame = setTimeout(() => {
            DrawRoofForPanel.subframeGroup.removeChildren();
            SubFrame.drawFramework();
            DrawRoofForPanel.subframeGroup.opacity(1);
            DrawRoofForPanel.layerPanel.batchDraw();

            //this.cutlistbtn.click();

            this.cutlistGroup = SubFrame.cutlistGroup;
            // reset modal if it isn't visible

        }, 200);
        this.showPanelsFlag = false;
        DrawRoofForPanel.panelGroup.opacity(0);
        DrawRoofForPanel.isViewPanelsEnabled = false;
        if (ModGroup.currentSelectedGroup) {
            ModGroup.currentSelectedGroup.opacity(0);
        }


    }

    onChangeCutProfileHandler(e: any) {
        if (this.showSubFrame) {
            clearTimeout(this.showSubFrame);
            this.showSubFrame = null;
        }

        if (e.checked) {
            this.showSubFrame = setTimeout(() => {
                this.updateSubframeDisplay({
                    isProfileCutEnabled: true,
                });
                this.cutlistbtn.click();
                this.cutlistGroup = SubFrame.cutlistGroup;
                const elements = document.getElementsByClassName('modal-backdrop');
                while (elements.length > 0) {
                    elements[0].parentNode?.removeChild(elements[0]);
                }
            }, 200);
        } else {
            this.updateSubframeDisplay({
                isProfileCutEnabled: false
            });
        }
    }


    showSubframeProfileCut() {
        this.updateSubframeDisplay({
            isProfileCutEnabled: true
        });
    }

    removeSubFrameProfileCut() {
        this.updateSubframeDisplay({
            isProfileCutEnabled: false
        });
    }

    //checkCutProfileLen
    checkCutProfileLen() {
        if (this.cutProfileLen < 10) {
            this.cutProfileLen = 10;
        }
    }


}
